export const themeEndpoints = (builder) => ({
    getThemes: builder.query({
        query: (userGroup) => ({url: `/instruments/themes?userGroup=${userGroup}`, method: 'get'}),
        transformResponse: (response) => {
            return response.sort((a, b) => b.meta.priority - a.meta.priority)
        },
        providesTags: ['Themes'],
    }),
    getThemeAssets: builder.query({
        query: (themeId) => ({url: `/instruments/themes/${themeId}`, method: 'get'}),
        providesTags: ['Themes'],
    }),
    updateTheme: builder.mutation({
        query: ({id, ...theme}) => ({url: `/instruments/themes/${id}`, method: 'put', body: theme}),
        invalidatesTags: ['Themes'],
    }),
    updateThemeImages: builder.mutation({
        query: ({id, ...data}) => ({url: `/instruments/themes/${id}/images`, method: 'put', body: data}),
        invalidatesTags: ['Themes'],
    }),
    updateThemesOrder: builder.mutation({
        query: (data) => ({url: `/instruments/themes/order`, method: 'put', body: data}),
        invalidatesTags: ['Themes'],
    }),
    createTheme: builder.mutation({
        query: ({theme}) => ({url: `/instruments/themes`, method: 'post', body: theme}),
        invalidatesTags: ['Themes'],
    }),
    deleteTheme: builder.mutation({
        query: ({id, meta, name}) => ({url: `/instruments/themes/${id}`, method: 'delete', body: { name, meta }}),
        invalidatesTags: ['Themes'],
    }),
})